import './Body.css';
import React, {useState} from "react";

import Footer from "./Footer.js"
import Header from "./Header.js"

import Home from './subpages/Home.js'
import About from './subpages/About.js'


function Body(props) {
    const [activeTab, setActiveTab] = useState("home")

    const contentMap = {
        "home": <Home setActiveTab={setActiveTab}/>,
        "about": <About setActiveTab={setActiveTab}/>,
    };

    return (
        <div className="body">
            <Header isMobile={props.isMobile} activeTab={activeTab} setActiveTab={setActiveTab}/>
            {contentMap[activeTab]}
            <Footer setActiveTab={setActiveTab}></Footer>
        </div>
    )
}

export default Body;